export default {
  state: {
    status: '',
    milestoneCategories: [],
  },
  mutations: {
    milestoneCategory_request(state) {
      state.status = 'loading';
    },
    milestoneCategory_success(state, milestoneCategories) {
      state.status = 'success';
      state.milestoneCategories = milestoneCategories;
    },
    milestoneCategory_error(state) {
      state.status = 'error';
    },
  },
  actions: {
    setMilestoneCategories({commit}, milestoneCategories) {
      commit('milestoneCategory_success', milestoneCategories);
    },
  },
  getters: {
    milestoneCategories: (state) => {
      return state.milestoneCategories;
    },
  },
};
